export default {
  home: {
    Home: 'Trực tiếp',
    Hot: 'Hot',
    Match: 'Lịch đấu',
    Message: 'Tin nhắn',
    Friend: 'Bạn bè',
    Me: 'Của tôi',
    Tab_0: 'Đề xuất',
    Tab_1: 'Bóng đá',
    Tab_2: 'Bóng rổ',
    Tab_3: 'Esports',
    Tab_4: 'Tin tức',
    Tab_5: 'Đêm khuya',
    Tab_6: 'Phát lại',
    index_title_zb: 'Đang hot',
    index_title_jc: 'Highlights',
    index_title_mx: 'Streamer nổi bật',
    index_title_qq: 'Thể thao điện tử',
    index_title_kx: 'Tin nhanh hôm nay',
    more: 'Thêm',
    jrrm: 'Hot hôm nay',
    jumpTop: 'Về đầu trang',
    onFocus: 'Theo dõi',
    reply: 'lượt trả lời',
    allComment: 'Tất cả bình luận',
    remen: 'Hot',
    saiguo: 'Kết quả',
    bsjj: 'Tổng hợp trận',
    qwzk: 'Đầy đủ nhất · Phát nhanh nhất',
    lggg: 'Tải miễn phí, Blu-ray & chiếu màn hình',
    downapp: 'Tải APP',
    anchortalk: 'Bình luận viên',
    currentsound: 'Âm thanh gốc',
    movieplayback: 'Phát lại',
    hightqulity: 'HD',
    pushlish: 'Đăng',
    abautanchor: 'Streamer liên quan',
    areadyfocus: 'Đã theo dõi',
    focus: 'Theo dõi',
    abautlive: 'Live liên quan',
    abautmatch: 'Lịch liên quan',
    yi: 'tỷ',
    wan: 'vạn',
    unkowntype: 'Không rõ loại',
    ballcircle: 'Cộng đồng bóng đá',
    staranchor: 'Streamer nổi bật',
    renhot: 'Độ hot: ',
    veryonesearch: 'Mọi người đang tìm',
    searchplace: 'Tìm nội dung quan tâm',
    zhongyao: 'Streamer',
    worldCupSchedule: 'Lịch đấu',
    worldCupScore: 'Tỷ số',
    worldCupNews: 'Tin tức',
    tabIdx: '1',
  },
  play: {
    chat: 'Chat',
    userzb: 'Streamer',
    saik: 'Diễn biến',
    zr: 'Đội hình',
    zs: 'Tỷ lệ',
    zb: 'Trực tiếp',
    fx: 'Phân tích',
    zbNoLine: 'Streamer chưa lên sóng',
    zbNoLine2: 'Theo dõi để nhận nhắc mở live～',
    joinInRoom: 'đã vào phòng chat',
    textLive: 'Tường thuật',
    tongji: 'Thống kê',
    team: 'Đội',
    teamTj: 'Thống kê đội',
    teamUserTj: 'Thống kê cầu thủ',
    yz: 'Kèo châu Á',
    rq: 'Chấp',
    jqs: 'Tổng bàn',
    zf: 'Tổng điểm',
    zlly: 'Nguồn kèo',
    fhv: 'Tỷ lệ hoàn',
    win: 'Thắng',
    draw: 'Hòa',
    owe: 'Thua',
    number: 'Số',
    teamUser: 'Cầu thủ',
    starter: 'Đá chính',
    time: 'Thời gian',
    score: 'Điểm',
    lb: 'Bắt bóng',
    zg: 'Kiến tạo',
    tl: 'Ném',
    sanfen: '3 điểm',
    fq: 'Ném phạt',
    qd: 'Cướp bóng',
    qb: 'Bắt bóng tấn công',
    hb: 'Bắt bóng phòng ngự',
    gm: 'Chặn bóng',
    sw: 'Mất bóng',
    fg: 'Phạm lỗi',
    chatText: 'Bóng phải tám mới vui~',
    gxzg: 'Chỉ số cao nhất',
    lsjz: 'Đối đầu',
    sv: 'Tỷ lệ thắng',
    ypl: 'Tỷ lệ thắng kèo',
    dql: 'Tỷ lệ Tài',
    ying: 'Thắng',
    shu: 'Thua',
    zou: 'Hòa kèo',
    xiao: 'Xỉu',
    da: 'Tài',
    jqzt: 'Phong độ gần đây',
    tss: 'Cùng giải',
    rqss: 'Ngày/Giải',
    dz: 'Cặp đấu',
    dx: 'Tài/Xỉu',
    copyline: 'Sao chép liên kết',
    sixin: 'Nhắn riêng',
    fensi: 'Fan',
    fds: 'Ghi nhớ tên miền dự phòng',
    ordownapp: 'Hoặc tải app',
    lodingtext: 'Đang tải chat',
    disstartmatch: 'Còn đến khi bắt đầu',
    zhu: 'Chủ',
    ke: 'Khách',
    chatHost: 'CSKH'
  },
  match: {
    jumpNowDay: 'Về hôm nay',
    refresh: 'Làm mới',
    mathDay: 'Ngày thi đấu',
    ban: 'Hiệp',
    jiao: 'Phạt góc',
    huangguan: '皇冠',
    libo: '立博',
    mingh: '明陞',
    bocai: '澳彩',
    wlxe: '威廉希尔',
    ysb: '易胜博',
    wd: '韦德',
    lij: '利记',
    yih: '盈禾',
    pb: '平博',
    year: 'Năm',
    moon: 'Tháng',
    nowDay: 'Hôm nay',
    onlive: 'Đang trực tiếp',
    dej: 'Q2',
    matcherr: 'Trận bất thường',
    nomatch: 'Chưa bắt đầu',
    dyj: 'Q1',
    dyjo: 'Hết Q1',
    dejo: 'Hết Q2',
    dsj: 'Q3',
    dsjo: 'Hết Q3',
    dsjj: 'Q4',
    matchjs: 'Hiệp phụ',
    matchwc: 'Hết trận',
    matchtc: 'Hoãn',
    matchzd: 'Gián đoạn',
    matchyz: 'Hủy',
    matchdd: 'Chờ định',
    matchsfqrqs: 'Bàn 3 điểm',
    matchefqrqs: 'Bàn 2 điểm',
    matchfqjqs: 'Ném phạt vào',
    matchsyzts: 'Còn timeout',
    matchfgs: 'Số lỗi',
    matchfqmzl: 'FT%',
    matchzzts: 'Tổng timeout',
    matchzg: 'Tấn công',
    matchwxjg: 'Tấn công nguy hiểm',
    matchkql: 'Kiểm soát bóng',
    matchszqm: 'Sút trúng đích',
    matchjq: 'Bàn thắng',
    matchdq: 'Pen',
    matchzg1: 'Kiến tạo',
    matchtime: 'Thời gian',
    matchhp: 'Thẻ đỏ',
    matchhp2: 'Thẻ vàng',
    matchsm: 'Sút',
    matchsz: 'Trúng đích',
    matchgr: 'Qua người',
    matchgrcg: 'Qua người thành công',
    matchjw: 'Phá bóng',
    matcyxzd: 'Chặn hiệu quả',
    matclj: 'Cắt bóng',
    matcqd: 'Cướp bóng',
    matccq: 'Chuyền',
    matccqcg: 'Chuyền chính xác',
    matchczq: 'Tạt bóng',
    matchczqcg: 'Tạt chính xác',
    matchcco: 'Chuyền dài',
    matchccok: 'Chuyền dài chính xác',
    matchpq: 'Tranh chấp',
    matchpqcg: 'Thắng tranh chấp',
    matchdqe: 'Mất bóng',
    matchfg: 'Phạm lỗi',
    matchbqf: 'Bị phạm lỗi',
    matchpj: 'Cứu thua',
    matchqjq: 'Đấm bóng',
    matchsmycj: 'Thủ môn băng ra',
    matchcjcg: 'Băng ra thành công',
    matchgkcj: 'Bắt bóng bổng',
    matchpf: 'Điểm số',
    matchjqs: 'Phạt góc',
    matchjwq: 'Ném biên',
    matchryq: 'Đá phạt',
    matchqmq: 'Phát bóng',
    matchhr: 'Thay người',
    matchbsks: 'Bắt đầu',
    matchzc: 'Giữa hiệp',
    matchjsg: 'Kết thúc',
    matchbcbf: 'Tỷ số HT',
    matchlhbh: 'Hai vàng thành đỏ',
    matchdqwj: 'Hỏng pen',
    matchwlq: 'Phản lưới',
    matchstbs: 'Bù giờ',
    matchsp: 'Sút lệch',
    matchjssjs: 'Hết hiệp phụ',
    matchjdqdz: 'Hết luân lưu',
    matchvar: 'VAR',
    matchspqm: 'Sút lệch khung',
    matchzysj: 'Sự kiện quan trọng',
    matchjss: 'Hiệp phụ',
    matchdqjs: 'Luân lưu',
    no: 'Không',
    chang: 'trận',
    tzk: 'Cùng chủ/khách',
    yes: 'Có',
    nos: 'Không',
    xiaojie: 'Hiệp',
    noLiveMatch: 'Chưa phát sóng',
  },
  noData: {
    noComment: 'Chưa có bình luận, nói gì đó',
    noSearch: 'Chưa có kết quả',
    noMatch: 'Hiện chưa có trận',
    nobifen: 'Chưa có dữ liệu tỷ số',
    noLive: 'Xem kênh khác, đang có live hay',
    nogroup: 'Chưa có nhóm',
    noNewfriend: 'Chưa có bạn mới',
    noqgg: 'Khám phá và đừng quên theo dõi streamer nhé',
    nozb: 'Chưa theo dõi streamer',
    noMsg: 'Chưa có tin',
  },
  tips: {
    shareMatch: 'Chia sẻ thành công',
    copySuccess: 'Sao chép thành công',
    changeLine: 'Đổi đường truyền',
    line: 'Tuyến',
    cancel: 'Hủy',
    tosendZb: 'Nhắn streamer xin vào nhóm',
    tosendhd: 'Tương tác với streamer nhé',
    addzb: 'Thêm streamer làm bạn để nhận dự đoán',
    gd: 'Còn nhiều streamer để hỏi～',
    tickoutgroup: 'Bạn đã bị đá khỏi nhóm',
    youforbid: 'Bạn đã bị cấm chat',
    younotin: 'Phòng chat không tồn tại',
    nomoredata: 'Hết dữ liệu',
    month: 'Tháng',
    day: 'Ngày',
    today: 'Hôm nay',
    kkry: 'Trống trơn~',
    ptaddress: 'Liên kết dự phòng',
    downloadApp: 'Tải APP',
    qwzk: 'Đầy đủ nhất · Phát nhanh nhất',
    lgtp: 'Tải miễn phí, Blu-ray & chiếu màn hình',
    myInvite: 'Lời mời của tôi',
    gjyaoqing: 'Tổng mời:',
    copyInviteLink: 'Sao chép link chia sẻ',
    person: 'người',
    chatcontent: 'Nội dung chat',
    addHomeScreen: 'Thêm vào màn hình chính',
    beat40: 'Bạn đã vượt 40% người dùng',
    beat60: 'Bạn đã vượt 60% người dùng',
    beat78: 'Bạn đã vượt 78% người dùng',
    beat88: 'Bạn đã vượt 88% người dùng',
    beat98: 'Bạn đã vượt 98% người dùng',
    haicha: 'Còn thiếu',
    czzksj: 'điểm để lên cấp',
    forbid: 'Đang bị cấm',
    loadFail: 'Tải thất bại',
    notSuport: 'Trình duyệt không hỗ trợ video',
    forwardApp: 'Chưa hỗ trợ, xem trên app',
    photo: 'Ảnh',
    video: 'Video',
    file: 'Tệp',
    redpot: 'Lì xì',
    upload: 'Đang tải lên',
    uploadFail: 'Tải lên thất bại！',
    yybtcql: 'Bạn đã bị đá khỏi nhóm',
    yybjy: 'Bạn đã bị cấm chat',
    ltsbcz: 'Phòng chat không tồn tại',
    sunday: 'Chủ nhật',
    monday: 'Thứ hai',
    tuesday: 'Thứ ba',
    wednesday: 'Thứ tư',
    thursday: 'Thứ năm',
    friday: 'Thứ sáu',
    saturday: 'Thứ bảy',
    search: 'Hủy',
  },
  im: {
    edit: 'Sửa',
    search: 'Tìm kiếm',
    inputPlaceholder: 'Nhập từ khóa',
    allin: 'Tất cả',
    add: 'Thêm',
    group: 'Nhóm chat',
    agree: 'Đã đồng ý',
    reject: 'Đã từ chối',
    pass: 'Thông qua',
    subitFriend: 'Xin kết bạn',
    activity: 'Trung tâm sự kiện',
    sedkf: 'Nói suy nghĩ của bạn',
    allSel: 'Chọn tất',
    yidu: 'Đánh dấu đã đọc',
    wanc: 'Hoàn tất',
    online: 'Trực tuyến',
    nowonline: 'Đang online',
    latestonline: 'Vừa online',
    contact: 'Liên hệ',
    newFriend: 'Bạn mới',
    mygfoup: 'Nhóm của tôi',
    mygscj: 'Tớ là “kho” hạnh phúc tốt nhất của bạn',
    wntuij: 'Gợi ý cho bạn',
    sound: '[Âm thanh]',
    video: '[Video]',
    image: '[Ảnh]',
    redpot: '[Lì xì]',
    link: '[Liên kết]',
    card: '[Danh thiếp]',
    getredpot: '[Nhận lì xì]',
    getreadysound: '[Chuẩn bị thoại trực tiếp]',
    transfer: '[Chuyển tiền]',
    groupcard: '[Thẻ nhóm]',
    recall: 'Thu hồi tin nhắn',
    checkorder: '[Xác nhận đơn]',
    file: '[Tệp]',
    zfhxx: '[Tin số thanh toán]',
    pay: '[Mini app]',
    ad: '[Quảng cáo]',
    talkover: '[Kết thúc cuộc gọi]',
    tips: '[Nhắc]',
    grouptips: '[Yêu cầu vào nhóm]',
    groupconfirm: '[Xác nhận vào nhóm]',
    notyoufriend: '[Đối phương chưa là bạn]',
    linknotyoufriend: '[Link mời vào nhóm]',
    groupsend: '[Gửi hàng loạt]',
    groupNotice: 'Thông báo nhóm',
    shouqi: 'Thu gọn',
    zhangkai: 'Mở rộng',
    groups: 'Nhóm'
  },
  me: {
    onLogin: 'Bấm để đăng nhập',
    tipsregst: 'Đăng ký để nhận nhiều ưu đãi',
    sign: 'Điểm danh',
    onsign: 'Đã điểm danh',
    jfsc: 'Cửa hàng điểm',
    zbxg: 'Liên quan streamer',
    gkls: 'Lịch sử xem',
    wddj: 'Cấp của tôi',
    yqhy: 'Mời bạn bè',
    zxkf: 'CSKH',
    zxzh: 'Hủy tài khoản',
    yqhydjf: 'Mời bạn nhận điểm',
    yjfk: 'Phản hồi',
    gywm: 'Về chúng tôi',
    setting: 'Cài đặt',
    lvxl: 'Tân binh',
    lvht: 'Đồng',
    lvby: 'Bạc',
    lvhj: 'Vàng',
    lvbj: 'Bạch kim',
    lvzs: 'Kim cương',
    lvbyqt: 'Caddy bạc',
    lvhtqm: 'Fan đồng',
    lvhjqy: 'Cầu thủ vàng',
    lvbjqx: 'Sao bạch kim',
    lvzsqw: 'Vua kim cương',
    srmi: 'Nhập mật khẩu',
    qdcg: 'Điểm danh thành công',
    jfgz: 'Quy tắc điểm',
    text3: '3: Mỗi ngày xem 10 phút',
    text1: '1: Cửa hàng điểm là phúc lợi miễn phí cho người dùng; chỉ cần là người dùng, bạn sẽ nhận điểm. Điểm có thể dùng để đổi quà giá trị hoặc phúc lợi nền tảng.',
    text1_2: '1: Cửa hàng điểm cung cấp phúc lợi miễn phí, điểm có thể dùng để đổi quà.',
    sigin1: 'Người dùng này chưa viết giới thiệu',
    quxiaocg: 'Hủy thành công',
    fzfxlj: 'Sao chép link chia sẻ',
    addimg: 'Thêm ảnh',
    zonecode: 'Mã vùng',
    zonecodedef: '86',
    inputphone: 'Nhập số điện thoại của bạn',
    videohp: 'Màn hình đen',
    mbf: 'Chưa có tỷ số',
    sxcg: 'Làm mới thành công',
    qsrplnr: 'Nhập nội dung bình luận',
    srname: 'Nhập tên của bạn',
    tgcggg: 'Gửi thành công, sẽ có nhân viên liên hệ bạn',
    zbxxsc: 'Tải lên thông tin streamer',
    qsrsfz: 'Nhập số CMND',
    zbnoid: 'Streamer chưa đặt ID',
    gzzb: 'Theo dõi streamer',
    lxkf: 'Liên hệ CSKH',
    phone: 'SĐT',
    code: 'Mã',
    dxyzm: 'Mã SMS',
    hqyzm: 'Lấy mã',
    symmdl: 'Đăng nhập bằng mật khẩu',
    dl: 'Đăng nhập',
    wyydbty: 'Tôi đã đọc và đồng ý',
    rjfwyx: '“Thỏa thuận giấy phép & dịch vụ”',
    zhen: 'Tài khoản',
    inputname: 'Nhập tài khoản',
    jxgg: 'Tiếp tục xem',
    yzmdl: 'Đăng nhập bằng mã',
    mm: 'Mật khẩu',
    qsrnc: 'Nhập biệt danh',
    jrqdhd: 'Điểm danh hôm nay nhận',
    textnone: 'I. Cách nhận điểm',
    text4: '4: Mời người dùng mới chia sẻ app',
    text2: '2: Hàng hóa chỉ đổi bằng điểm, không dùng tiền hoặc cách khác.',
    signname: 'Chữ ký',
    gzcg: 'Theo dõi thành công',
    fzljcg: 'Sao chép thành công',
    zdyz: '(tối đa một ảnh)',
    submit: 'Gửi',
    mflt: 'Không chat được',
    bsts: 'Ít trận quá',
    abouttext1: 'Là nền tảng truyền thông thể thao tổng hợp thế hệ mới trên Internet, sở hữu bản quyền hơn 50 giải đấu tầm cỡ trong nước và quốc tế như CSL, AFC Champions League, Premier League, Serie A, Ligue 1, La Liga, UEFA Champions League, EURO, World Cup…; trở thành nền tảng xem, bàn luận và tương tác về sự kiện thể thao cho lượng lớn người dùng yêu thể thao.',
    tpisnodata: 'Bạn chưa nhập nội dung',
    plcg: 'Bình luận thành công',
    srndsjh: 'Nhập số điện thoại của bạn',
    oninutphone: 'Vui lòng nhập đúng số điện thoại',
    zjhm: 'Số giấy tờ',
    tccg: 'Thoát thành công',
    mhtcsy: 'giây sau về trang chủ',
    nrwk: 'Nội dung trống',
    tyfwxy: 'Vui lòng đồng ý thỏa thuận dịch vụ',
    qsrmm: 'Vui lòng nhập mật khẩu',
    newpass: 'Mật khẩu mới',
    inputnewpass: 'Nhập mật khẩu mới',
    grzl: 'Hồ sơ cá nhân',
    avatar: 'Ảnh đại diện',
    username: 'Biệt danh',
    gxqm: 'Chữ ký cá nhân',
    nosetting: 'Chưa đặt',
    xtavatar: 'Ảnh hệ thống',
    xc: 'Album',
    qxztx: 'Chọn ảnh đại diện',
    wjbncg: 'Kích thước tệp không vượt quá 1MB',
    imgsubimterr: 'Tải ảnh thất bại, vui lòng thử lại',
    tpscz: 'Đang tải ảnh lên',
    qscjpg: 'Vui lòng tải ảnh định dạng jpg/png',
    scz: 'Đang tải lên...',
    hqsb: 'Lấy ảnh hệ thống thất bại',
    szcg: 'Thiết lập thành công',
    sznc: 'Đặt biệt danh',
    xlqd: 'Bạn đã điểm danh liên tục',
    tian: 'ngày',
    mrqd1: '1: Điểm danh mỗi ngày',
    mrqd2: '(Điểm danh 7 ngày liên tục nhận thêm gói điểm)',
    aboutjfsc: 'II. Về cửa hàng điểm',
    jfdhjp: '3: Đổi quà cần cung cấp địa chỉ, điện thoại và người nhận chính xác; nền tảng chịu trách nhiệm miễn phí vận chuyển toàn quốc.',
    mygdl: 'Không còn nữa',
    zzzb: 'Đang trực tiếp',
    fklex: 'Loại phản hồi',
    fkcgprd: '(Phản hồi thành công có cơ hội nhận phúc lợi)',
    tgcg: 'Gửi thành công',
    syhm: 'Lệch tiếng/hình',
    cpty: 'Trải nghiệm sản phẩm',
    testx1: 'Nỗ lực xây dựng nền tảng thể thao Internet phục vụ người hâm mộ toàn cầu; ra mắt ứng dụng thể thao độc lập theo chiều dọc với đổi mới nghiệp vụ; thông qua tăng cường tương tác và tạo nội dung thể thao phong phú, toàn diện hơn để cung cấp dịch vụ thông tin 7×24 giờ.',
    ltpf: 'Chat quá dày, thử lại sau~',
    mmbns6: 'Mật khẩu không dưới 6 ký tự',
    srxxdz: 'Nhập địa chỉ chi tiết của bạn',
    qzqtx: 'Vui lòng điền đúng thông tin',
    qsrzsmz: 'Vui lòng nhập tên thật',
    nylqgl: 'Bạn đã nhận rồi',
    nccccc: '1. Biệt danh chỉ được sửa 1 lần trong 1 ngày, không quá 6 ký tự.',
    textnc: '2. Biệt danh chỉ cho phép nhập tiếng Trung',
    textnc3: '3. Sau khi sửa, nếu qua duyệt thủ công phát hiện vi phạm sẽ bị đặt lại.',
    ncxt: 'Biệt danh trùng, vui lòng sửa rồi gửi',
    ncbnwk: 'Biệt danh không được để trống',
    idszh: 'ID là chứng cứ duy nhất của tài khoản, không thể sửa',
    szgxqm: 'Đặt chữ ký cá nhân',
    qsrgxqm: 'Vui lòng nhập chữ ký của bạn',
    qsxt: 'Chữ ký trùng, vui lòng sửa rồi gửi',
    qsbnwk: 'Chữ ký không được để trống',
    jfgza: 'Quy tắc',
    lxqdyjx: 'Điểm danh liên tục, nhận quà bất ngờ',
    jfmx: 'Chi tiết điểm',
    jfdhzq: 'Khu đổi điểm',
    ckwdhd: 'Xem hàng tôi đã đổi',
    jfci: 'điểm/lần',
    jf: 'Điểm',
    dh: 'Đổi',
    dhsy: 'Dùng điểm đổi xong không thể hủy',
    ckkdh: 'Xem hàng có thể đổi',
    zbgphd: '2: Tương tác trên khung chat',
    zbgphd2: '(mỗi ngày một lần)',
    smjfsc: 'Cửa hàng điểm là gì?',
    textp4: '4: Nền tảng có quyền điều chỉnh quy tắc cửa hàng điểm và thông báo bất cứ lúc nào; nếu xuất hiện lỗ hổng hoạt động hoặc hành vi gian lận quy mô lớn (bao gồm nhưng không giới hạn ở việc hưởng quyền lợi không theo quy trình bình thường), nền tảng có quyền — trong phạm vi quy định cho phép — trực tiếp dừng/đóng hoạt động và thu hồi quyền lợi, đồng thời giữ quyền thay đổi các quy tắc và điều khoản.',
    qxgz: 'Bỏ theo dõi',
    lsjl: 'Lịch sử',
    fknr: 'Nội dung phản hồi',
    gxydkn: 'Gặp khó khi cập nhật',
    bstk: 'Trận xem bị giật/lag',
    qsrnyfk: 'Vui lòng nhập nội dung phản hồi',
    wl1: 'Tương lai',
    wlyt: 'Sẽ dựa trên chuyên môn vận hành giải đấu, khám phá kết nối xuyên ngành đa lĩnh vực, xây dựng hệ sinh thái dịch vụ người dùng toàn cảnh. Tập trung vào cộng đồng người hâm mộ nội dung thể thao, liên tục dùng năng lực vận hành IP dẫn đầu ngành để phục vụ người dùng thể thao, mang đến các sự kiện thể thao hàng đầu, xây dựng dịch vụ tư vấn và nội dung thể thao, kiến tạo một nền tảng sức khỏe thể thao mang bản sắc — để đam mê càng thêm đam mê.',
    xtts: 'Nhắc hệ thống: Chúng tôi nỗ lực xây dựng môi trường live tích cực, lành mạnh và kiểm tra nội dung 24/7; mọi hành vi phát tán thông tin vi phạm pháp luật/quy định, lừa đảo, phản cảm, bạo lực máu me, mê tín phong kiến… khi phát hiện sẽ bị khóa tài khoản.',
    chgangsu: 'Sửa thành công',
    inputcode: 'Nhập mã bưu chính',
    yazfa: 'Mã đã gửi',
    xingming: 'Họ tên',
    lingquceng: 'Nhận thành công',
    loginSucces: 'Đăng nhập thành công',
    backhome: 'Về trang chủ',
    inputphonecode: 'Nhập mã xác minh',
    setPass: 'Đặt mật khẩu',
    yset: 'Đã đặt',
    out: 'Đăng xuất',
    setpasstips: 'Sau khi đặt có thể đăng nhập bằng tài khoản + mật khẩu',
    ok: 'OK',
    pssmy: 'Xác minh mật khẩu',
    zxhb: 'Lì xì đặc biệt',
    zxhbjf: 'Lì xì điểm riêng',
    lq: 'Nhận',
    ylq: 'Đã nhận',
    mystatk: 'Nhiệm vụ của tôi',
    mystat2k: 'Giá trị trưởng thành',
    qbtj: 'Thống kê tất cả',
    zbgg: 'Thông báo streamer',
    nozbgg: 'Streamer chưa có thông báo',
    xianlu: 'Tuyến',
    gxni: 'Chúc mừng, bạn nhận lì xì tiền mặt',
    gxsssni: 'Hãy vào nhắn riêng streamer để nhận～',
    loding: 'Đang tải dữ liệu, vui lòng đợi～',
    yuan: '¥',
    sedmsg: 'đã gửi cho bạn một tin',
    chakan: 'Xem',
    del: 'Xóa',
    sp: 'Tăng kèo',
    jp: 'Giảm kèo',
    gs: 'Nước cao',
    ds: 'Nước thấp',
    pkly: 'Nguồn kèo',
    cspk: 'Kèo mở đầu',
    jspk: 'Kèo hiện tại',
    qy: 'Cầu thủ',
    sf: 'Đá chính',
    mtsc: '(mỗi ngày 3 lần)',
    sq: 'Thu gọn',
    sfzr: 'Đội hình chính',
    tbzr: 'Đội hình dự bị',
    zx: 'Sơ đồ',
    chu: 'Mở đầu',
    ji: 'Hiện tại',
    lhyh: 'Hai vàng một đỏ',
    wl: 'Phản lưới',
    sjhgscw: 'Định dạng SĐT không đúng',
    inputsjyzm: 'Vui lòng nhập mã SMS',
    inputzonecode: 'Vui lòng nhập mã vùng',
    loginsuccback: 'Đăng nhập thành công, 3 giây sau về trang chủ',
    loginsucc: 'Đăng nhập thành công, ',
    threeback: 'giây sau về trang chủ',
    loginfail: 'Đăng nhập thất bại.',
    welcome: 'Chào mừng đến',
    logintips: 'Đăng nhập bằng số điện thoại, không cần đăng ký',
    integralExchange: 'Đổi thành công',
    integralSuccess: 'Chúc mừng bạn đã đổi thành công',
    integralExchanged: 'Đã đổi điểm',
    integralNumber: 'Điểm còn lại',
    integralContinue: 'Tiếp tục đổi',
    integralTips: '*Hãy hoàn thiện địa chỉ nhận hàng trong mục hàng đã đổi; sau khi nhân viên xác nhận sẽ tự động gửi; do hệ thống, không cung cấp thông tin vận chuyển.',
    texttoolong: 'Không vượt quá 6 ký tự',
    nickMdySucc: 'Đổi biệt danh thành công',
    onlyUseChina: 'Biệt danh chỉ dùng tiếng Trung, vui lòng nhập lại',
    addaddress: 'Thêm địa chỉ',
    addressdetail: 'Nhập địa chỉ chi tiết, khu vực và số nhà/đường',
    inputdetail: '*Lưu ý: đảm bảo hàng có thể giao đúng; địa chỉ cần chi tiết; chỉ có một lần điền; sẽ gửi trong 1–3 ngày làm việc.',
    integralex: 'Nhận từ đổi điểm',
    delaccount: 'Hủy tài khoản — lưu ý:',
    delaccontent1: 'Để tránh thao tác nhầm, hãy xác nhận lại việc hủy và hậu quả. Hủy là không thể khôi phục; khuyến nghị tự sao lưu toàn bộ thông tin liên quan trước khi hủy.',
    delaccontent2: '1. Hồ sơ cá nhân và lịch sử (ảnh đại diện, tên, nội dung đăng, lịch sử xem…) sẽ không thể khôi phục',
    delaccontent3: '2. Bạn sẽ không thể đăng nhập và sử dụng tài khoản này.',
    delaccontent4: '3. Các tài khoản bên thứ ba đăng nhập/ủy quyền bằng tài khoản này sẽ không thể khôi phục; mọi quyền lợi ảo coi như tự nguyện từ bỏ. Sau khi hủy, SĐT sẽ được bỏ liên kết; bỏ liên kết xong có thể đăng ký lại. Vui lòng thao tác thận trọng',
    delaccontent5: 'Nhập đúng UID hiện tại và bấm xác nhận; tài khoản của bạn sẽ bị hủy không thể đảo ngược, hãy cân nhắc kỹ!!!',
    delaccontent6: 'Vui lòng nhập UID đầy đủ',
    delaccontent7: 'Vui lòng nhập UID',
    delaccontent8: 'ID bạn nhập không đúng',
    submitted: 'Đã gửi',
    success: 'Thành công',
    failed: 'Thất bại',
    invitecode: 'Mã mời',
    inputInviteCode:'Không bắt buộc',
    withdrawFailed: 'Đổi thất bại',
    inputaccount: 'Nhập tài khoản (6–20 chữ + số)',
    inputpassword: 'Nhập mật khẩu (6–20 chữ hoặc số)',
    inputpasswordagain: 'Nhập lại mật khẩu',
    accountInvalid: 'Tài khoản không hợp lệ',
    gotoLogin: 'Tới đăng nhập',
    gotoRegister: 'Tới đăng ký',
    querenpwd: 'Xác nhận mật khẩu',
    inputnickname: 'Nhập biệt danh',
    register: 'Đăng ký ngay',
    pwsswordInvalid: 'Vui lòng nhập đúng mật khẩu',
    pwsswordNotSame: 'Hai lần nhập mật khẩu không khớp',
    setAccPwd: 'Đặt tài khoản & mật khẩu',
    setAccPwdSubTitle: 'Sau khi đặt có thể đăng nhập bằng tài khoản/mật khẩu',
    inputOldPassword: 'Nhập mật khẩu cũ',
    newPassword: 'Mật khẩu mới',
    oldPassword: 'Mật khẩu cũ',
    passwordIsSame: 'Mật khẩu mới trùng mật khẩu cũ',
    accPwdError: 'Tài khoản hoặc mật khẩu không đúng',
    nickNameErr: 'Biệt danh 6–20 ký tự gồm chữ, số hoặc ký tự phổ biến',
    accountRepeated: 'Tài khoản đã tồn tại',
    nicknameRepeated: 'Biệt danh đã tồn tại',
    setSucc: 'Thiết lập thông tin thành công', 
    regSucc: 'Đăng ký thành công, đang tự động đăng nhập',
    switchAccount: 'Chuyển tài khoản',
  },
  'jinqiu': 'Bàn thắng',
  'focuSucc': 'Theo dõi thành công',
  'cancelFocus': 'Bỏ theo dõi thành công',
  'clearCache': 'Xóa bộ nhớ đệm',
  "复制": "Sao chép",
  "邀请的人数": "Số người đã mời",
  "查看记录": "Xem lịch sử",
  "可兑换积分": "Điểm có thể đổi",
  "兑换话费": "Đổi cước thoại",
  "兑换彩金": "Đổi tiền thưởng",
  "立即邀请": "Mời ngay",
  "记录": "Lịch sử",
  "好友记录": "Lịch sử bạn bè",
  "兑换记录": "Lịch sử đổi",
  "兑换": "Đổi",
  "确认兑换奖金吗？": "Xác nhận đổi thưởng？",

  "规则":"Quy tắc",
  "碎片":"Mảnh",
  "转盘次数":"Lượt quay",
  "奖品兑换":"Đổi quà",
  "每日奖励":"Thưởng mỗi ngày",
  "每日登录JALALIVE并观看比赛":"Mỗi ngày đăng nhập JALALIVE và xem trận",
  "转盘机会 +1":"+1 lượt quay",
  "活动规则":"Quy tắc sự kiện",
  "确认兑换吗？":"Xác nhận đổi?",
  "谢谢惠顾":"Cảm ơn đã tham gia",
  "恭喜您获得":"Chúc mừng bạn nhận",
  "未达成":"Chưa đạt",
  "领取":"Nhận",
  "已领取":"Đã nhận",
  "数据异常或网络异常":"Lỗi dữ liệu hoặc mạng",
  "兑换成功":"Đổi thành công",
  "兑换失败":"Đổi thất bại",
  "收下":"Nhận",
  "立即参与":"Tham gia ngay",

  "兑换奖品":"Đổi quà",
  "兑换积分":"Đổi điểm",
  "兑换奖励":"Đổi thưởng",
  "前往JalaLive积分商城":"Tới Cửa hàng điểm JalaLive",
  "积分可以去兑换商品":"Dùng điểm để đổi hàng",
  "前往":"Tới",

  "非法手机号":"SĐT không hợp lệ",
  "发送短信失败":"Gửi SMS thất bại",
  "温馨提示":"Nhắc nhở",
  "您尝试登录的手机号已存在绑定的账号，请使用账号密码登录。平台即将移除手机号验证码登录方式":"SĐT bạn dùng để đăng nhập đã liên kết tài khoản; hãy dùng tài khoản + mật khẩu. Nền tảng sắp gỡ đăng nhập bằng mã SMS",
  "我知道啦":"Tôi biết rồi",
  "通知":"Thông báo",
  "平台即将移除手机号验证码登录方式，系统已自动为您生成账号，请补全其他信息，后续请使用账号密码登录！":"Nền tảng sắp gỡ đăng nhập bằng mã SMS; hệ thống đã tự tạo tài khoản cho bạn, vui lòng bổ sung thông tin và sau đó dùng tài khoản + mật khẩu để đăng nhập!",
  "账号（不可更改）":"Tài khoản (không đổi)",
  "设置密码":"Đặt mật khẩu",
  "请输入密码":"Vui lòng nhập mật khẩu",
  "设置邮箱（用于找回密码，可选）":"Đặt email (để khôi phục, tùy chọn)",
  "请输入邮箱":"Vui lòng nhập email",
  "忘记密码？":"Quên mật khẩu?",
  "邮箱验证":"Xác minh email",
  "请输入验证码":"Vui lòng nhập mã xác minh",
  "获取验证码":"Lấy mã",
  "邮箱格式不正确":"Định dạng email không đúng",
  "温馨提示：如果您没有绑定过邮箱，请联系客服找回密码":"Nhắc: Nếu bạn chưa liên kết email, hãy liên hệ CSKH để lấy lại mật khẩu",
  "设置邮箱":"Đặt email",
  
  "温馨提示：绑定邮箱可用于找回密码":"Nhắc: Liên kết email có thể dùng để lấy lại mật khẩu",
  "奖品剩余：":"Còn lại:",
  "VIP折扣说明":"Mô tả giảm giá VIP",
  "VIP折扣":"Giảm giá VIP",
  "无折扣":"Không giảm",
  "折":"giảm",
  "查看VIP详情":"Xem chi tiết VIP",
  "礼物折扣":"Giảm giá quà",
  "支付":"Thanh toán",

  "竞猜":"Dự đoán",
  "我的积分":"Điểm của tôi",
  "竞猜记录":"Lịch sử dự đoán",
  "截止时间":"Hạn chót",
  "选择下注积分":"Chọn điểm đặt",
  "下注":"Đặt cược",
  "下注成功":"Đặt thành công",
  "比赛":"Trận đấu",
  "竞猜结果":"Kết quả dự đoán",
  "竞猜成功":"Dự đoán đúng",
  "竞猜失败":"Dự đoán sai",
  "未开奖":"Chưa mở thưởng",
  "投注失败，积分不足":"Đặt thất bại, điểm không đủ",

  "（主）":"（Chủ）",
  "（客）":"（Khách）",
  "主队赢":"Chủ thắng",
  "平":"Hòa",
  "客队赢":"Khách thắng",
  "版本":"Phiên bản",
  "查看详情":"Xem chi tiết",
  "斗鸡":"ĐÁ GÀ",
  "体育":"Thể thao",
  "当前斗鸡比赛较少，去体育频道看看吧": "Hiện ít trận đá gà. Vào mục Thể thao nhé.",
  "前往体育频道": "Đến mục Thể thao",

  "(在线中…)": "(Đang online...)",
  "暂无群组": "Chưa có nhóm",
  "暂无与主播私聊信息": "Chưa có tin nhắn riêng",
  "请找主播添加您进群获得福利": "Nhắn host để vào nhóm và nhận ưu đãi",
  "请私信主播吧~": "Nhắn riêng host nhé~",
  "主播私聊": "Nhắn riêng host",
  "群组": "Nhóm",
  "发送":"Gửi",
  "您的聊天已受限，请联系主播或客服":"Chat bị hạn chế. Liên hệ host hoặc CS.",
  "发送失败，未知错误":"Gửi thất bại. Lỗi không xác định.",
};
